import React from 'react';
import PropTypes from 'prop-types';

import Accordion from 'components/accordion';
import Back from 'components/back';
import Breadcrumbs from 'components/breadcrumbs';
import ContactCards from 'components/contact-cards';
import ContentBlock from 'components/content-block';
import EditProfile from 'components/edit-profile';
import EventList from 'components/event-list';
import FavoriteTiles from 'components/favorite-tiles';
import FileDownloadList from 'components/file-download-list';
import Form from 'components/form';
import FullWidthCTA from 'components/full-width-cta';
import Header from 'components/Header';
import Image from 'components/_common/image';
import ImageGallery from 'components/image-gallery';
import ListLanguageFolder from 'components/list-language-folder';
import MainImage from 'components/main-image';
import MultipleContact from 'components/multiple-contact';
import NotFound from 'components/not-found';
import NotificationDetail from 'components/notification-detail';
import NotificationHeader from 'components/notification-header';
import NotificationPreviewList from 'components/notification-preview-list';
import OrderingTool from 'components/ordering-tool';
import PDFViewer from 'components/pdf-viewer';
import PortalSearchResult from 'components/portal-search-result';
import PowerBI from 'components/power-bi';
import RequestAccess from 'components/request-access';
import RequestAccessNew from 'components/request-accessnew';
import RichText from 'components/rich-text';
import Signup from 'components/sign-up/Signup';
import Table from 'components/table';
import Tiles from 'components/tiles';
import VideoPlayer from 'components/video-player';
import ViewProfile from 'components/view-profile';

const ComponentSwitch = ({ component, ...props }) => {
  if (!component) {
    return null;
  }
  const { templateLabel } = component;
  const components = {
    'Accordion Template': Accordion,
    'Back Template': Back,
    'Breadcrumbs Template': Breadcrumbs,
    'Call To Action Template': FullWidthCTA,
    'Contact Card Template': ContactCards,
    'Edit Profile Template': EditProfile,
    'Error Template': NotFound,
    'Event List Template': EventList,
    'Favorite Tiles Template': FavoriteTiles,
    'File Download List Template': FileDownloadList,
    'Form Template': Form,
    'Header Template': Header,
    'Header With Text Template': ContentBlock,
    'Image Gallery Template': ImageGallery,
    'Image Template': Image,
    'List Language Folder Template': ListLanguageFolder,
    'Login Template': Signup,
    'Main Image Template': MainImage,
    'Multiple Contact Template': MultipleContact,
    'Notification Header Template': NotificationHeader,
    'Notifications List Template': NotificationDetail,
    'Notifications Preview Template': NotificationPreviewList,
    'Ordering Tool Template': OrderingTool,
    'PDF Viewer Template': PDFViewer,
    'Power BI Template': PowerBI,
    'Request Access Template': RequestAccess,
    'Request Accessnew Template': RequestAccessNew,
    'Rich Text Template': RichText,
    'Search Result Template': PortalSearchResult,
    Signup: Signup,
    'Table Template': Table,
    'Tile List Template': Tiles,
    'Video Player Template': VideoPlayer,
    'View Profile Template': ViewProfile,
  };
  const Component = components[templateLabel];

  if (!Component) {
    return <p>No component found for {templateLabel}</p>;
  }

  return <Component {...props} {...component} />;
};

ComponentSwitch.propTypes = {
  component: PropTypes.shape({
    templateLabel: PropTypes.string,
  }),
};

export default ComponentSwitch;
